import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { LoginService } from "./login.service";
import { AbstractService } from "./abstract.service";
import { HabilMobilePDVProduto } from "../models/habil-mobile-pdv-produto";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class HabilMobilePdvProdutoService extends AbstractService<HabilMobilePDVProduto> {
  constructor(
    public http: HttpClient,
    private router: Router,
    public loginService: LoginService
  ) {
    super(http, loginService);
  }

  titulo: string = "Hábil Mobile PDV";

  endpoint(): string {
    return "registro/habil-mobile-pdv-produto";
  }

  rotina(): string {
    return "HABIL_MOBILE_PDV_PRODUTO";
  }

  colunas(): any[] {
    return [
      { header: "Código", field: "id" },
      { header: "Nome", field: "nomeProduto" },
    ];
  }

  corrigeAtributos(t: any): HabilMobilePDVProduto {
    t.acessos = [];
    for (let acesso of t["acessosComDescricao"]) {
      t.acessos.push(acesso.value);
    }
    t["acessosComDescricao"] = [];
    return super.corrigeAtributos(t);
  }

  private getHeaders(): HttpHeaders {
    return new HttpHeaders({
      Accept: "application/json; charset=utf-8",
      "X-Auth-Token": AbstractService.token(),
    });
  }

  getModulosAdicionais(): Observable<any[]> {
    const url = this.baseUrl() + "/modulos-adicionais";

    return this.http.get<any[]>(url, { headers: this.getHeaders() });
  }

  getAcessos(): Observable<any> {
    const url = this.baseUrl() + "/acessos";

    return this.http.get<any[]>(url, { headers: this.getHeaders() });
  }

  novo(selection?: any) {
    AbstractService.readonly = false;
    this.router.navigate(["adm/produtos/cadastro-habil-mobile-pdv"]);
  }

  abrir(obj: HabilMobilePDVProduto) {
    AbstractService.readonly = true;
    this.router.navigate([
      "adm/produtos/cadastro-habil-mobile-pdv",
      { query: { id: obj.id } },
    ]);
  }

  edit(obj: HabilMobilePDVProduto) {
    AbstractService.readonly = false;
    this.router.navigate([
      "adm/produtos/cadastro-habil-mobile-pdv",
      { query: { id: obj.id } },
    ]);
  }

  routeLista() {
    return "adm/produtos";
  }
}
